import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Stack,
  TextField,
  Grid
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import getAuditlogsActions from "../../redux/auditlogs/action";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import GreenButton from "../../common/button/greenButton";
import xlsx from "json-as-xlsx";
import { AlphabetsValidation, InputTrimAndLowercaseFunction, MobileNumberFirstNumberValidation, MobileNumberValidation, handleEmailValidation } from '../../utils/validation';
import { useForm } from "react-hook-form";
import axios from "axios"
export default function LogsSelector() {
  const [value, setValue1] = useState("");
  const dispatch = useDispatch();
  const { Auditlogs } = useSelector((state) => state.AuditlogsReducer);
  // let settings = {
  //   fileName: "Auditlogs Report",
  //   extraLength: 3,
  //   writeMode: "writeFile",
  //   writeOptions: {},
  //   RTL: false,
  // };
  // let callback = function (sheet) {
  // };
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    trigger,
  
    formState: { errors }
  } = useForm({ mode: "all" });
  // const handledownload = async () => {
  //   if (Auditlogs?.result && Auditlogs?.result.length > 0) {
  //     let columns = [];

  //     for (let i = 0; i < Object.keys(Auditlogs?.result[0]).length; i++) {
  //       let obj = {};
  //       obj.label = Object.keys(Auditlogs?.result[0])[i];
  //       obj.value = Object.keys(Auditlogs?.result[0])[i];
  //       columns.push(obj);
  //     }

  //     let data = [
  //       {
  //         sheet: "AdmitCard Total Candidate",
  //         columns: columns,
  //         content: Auditlogs?.result,
  //       },
  //     ];
  //     xlsx(data, settings, callback);
  //   } else {
  //   }
  // };
  // const handledownload = async () => {
  //   if (Auditlogs && Auditlogs?.length > 0) {
  //     // const flattenObject = (obj, parent = '', res = {}) => {
  //     //   for (let key in obj) {
  //     //     let propName = parent ? parent + '.' + key : key;
  //     //     if (typeof obj[key] === 'object' && obj[key] !== null) {
  //     //       // If it's an array or object, stringify it
  //     //       if (Array.isArray(obj[key])) {
  //     //         res[propName] = JSON.stringify(obj[key]);
  //     //       } else {
  //     //         flattenObject(obj[key], propName, res);
  //     //       }
  //     //     } else {
  //     //       res[propName] = obj[key];
  //     //     }
  //     //   }
  //     //   return res;
  //     // };

  //     // const flattenObject = (obj, parent = '', res = {}) => {
  //     //   for (let key in obj) {
  //     //     if (!obj.hasOwnProperty(key)) continue;

  //     //     let value = obj[key];
  //     //     let propName = parent ? `${parent}.${key}` : key;

  //     //     if (typeof value === 'object' && value !== null) {
  //     //       // Recurse if it's an object (including nested old_data)
  //     //       if (Array.isArray(value)) {
  //     //         res[propName] = JSON.stringify(value); // convert arrays to string
  //     //       } else {
  //     //         flattenObject(value, propName, res);
  //     //       }
  //     //     } else {
  //     //       res[propName] = value ?? ""; // replace null/undefined with empty string
  //     //     }
  //     //   }
  //     //   return res;
  //     // };

  //     let flatContent = Auditlogs.map((item) => {
  //       if (item.old_data && item.old_data != null) {
  //         item = { ...item, old_data: JSON.stringify(item.old_data) };
  //       }
  //       if (item.obj_data && item.obj_data != null) {
  //         item = { ...item, obj_data: JSON.stringify(item.obj_data) };
  //       }
  //       return item;
  //     });
  //     // let flatContent = Auditlogs?.result?.map(item => flattenObject(item));

  //     let columns = Object.keys(flatContent[0]).map((key) => ({
  //       label: key,
  //       value: key,
  //     }));

  //     let data = [
  //       {
  //         sheet: "AdmitCard Total Candidate",
  //         columns: columns,
  //         content: flatContent,
  //       },
  //     ];

  //     let settings = {
  //       fileName: "AuditLogsExport",
  //     };

  //     let callback = function () {
  //     };

  //     xlsx(data, settings, callback);
  //   } else {
  //   }
  // };

  const handledownload = async () => {
    if (Auditlogs && Auditlogs?.length > 0) {
      const formatDateToIST = (dateValue) => {
        if (!dateValue) return dateValue;
        
        // If already formatted (from SQL), return as-is
        if (typeof dateValue === 'string' && dateValue.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2} (AM|PM)/)) {
          return dateValue;
        }
  
        // Convert to IST with AM/PM
        const date = new Date(dateValue);
        return date.toLocaleString('en-IN', {
          timeZone: 'Asia/Kolkata',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true // Ensures AM/PM format
        }).replace(/(\d+)\/(\d+)\/(\d+),/, '$3-$2-$1'); // Format as YYYY-MM-DD HH:MM:SS AM/PM
      };
  
      const formattedData = Auditlogs.map(item => {
        const newItem = { ...item };
  
        // Format date fields to IST with AM/PM
        if (newItem.createddate) {
          newItem.createddate = formatDateToIST(newItem.createddate);
        }
        if (newItem.updateddate) {
          newItem.updateddate = formatDateToIST(newItem.updateddate);
        }
        if (newItem.viewedtime) {
          newItem.viewedtime = formatDateToIST(newItem.viewedtime);
        }
  
        // Stringify JSON fields
        if (newItem.old_data) {
          newItem.old_data = JSON.stringify(newItem.old_data);
        }
        if (newItem.obj_data) {
          newItem.obj_data = JSON.stringify(newItem.obj_data);
        }
  
        return newItem;
      });
  
      // Create columns
      const columns = Object.keys(formattedData[0]).map(key => ({
        label: key,
        value: key,
      }));
  
      // Export to Excel
      const data = [{
        sheet: "AuditLogs",
        columns: columns,
        content: formattedData,
      }];
  
      const settings = {
        fileName: "AuditLogsExport_" + new Date().toISOString().split('T')[0],
      };
  
      xlsx(data, settings);
    } else {
    }
  };
  


  useEffect(() => {
    dispatch({
      type: getAuditlogsActions.SET_AUDITLOGS,
      payload: [],
    });
  }, []);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    dispatch({
      type: getAuditlogsActions.SET_AUDITLOGS,
      payload: [],
    });

    setValue1(selectedValue);
  };
  const handlelogs = () => {
    const inputValue = getValues("mobileno"); 

      dispatch({
        type: getAuditlogsActions.GET_AUDITLOGS,
        // payload: value,
        payload: {
          Value: value,
          input: inputValue || null,
        },
      });
 
  };
  // const keycloakUrl = "https://auth.mhcet-reg-dev.hubblehox.ai";
  // const realm = "master";
  // const clientId = "admin-cli";
  // const adminUsername = "admin";
  // const adminPassword = "MCHT2@2$hh";

  // const getAdminToken = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${keycloakUrl}/realms/${realm}/protocol/openid-connect/token`,
  //       new URLSearchParams({
  //         client_id: clientId,
  //         username: adminUsername,
  //         password: adminPassword,
  //         grant_type: "password",
  //       }).toString(),
  //       {
  //         headers: {
  //           "Content-Type": "application/x-www-form-urlencoded",
  //         },
  //       }
  //     );
  //     return response.data.access_token;
  //   } catch (error) {
  //     console.error("Error fetching admin token:", error);
  //     throw error;
  //   }
  // };

  // const getUsers = async () => {
  //   try {
  //     const token = await getAdminToken();
      
  //     const response = await axios.get(
  //       `${keycloakUrl}/admin/realms/${realm}/users`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
      
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //     throw error;
  //   }
  // };
  

  
  return (
    // <Box sx={{ p: 2 }}>
    //   <Typography variant="h6" gutterBottom>
    //     Select Logs
    //   </Typography>
    //   <FormControl sx={{ minWidth: 200 }} size="small">
    //     <Select
    //       value={value}
    //       onChange={handleChange}
    //       displayEmpty
    //       fullWidth
    //     >
    //       <MenuItem value="">
    //         Select logs
    //       </MenuItem>
    //       <MenuItem value={1}>Profile Logs</MenuItem>
    //       <MenuItem value={2}>Course Registration Logs</MenuItem>
    //       <MenuItem value={3}>Objection Tracker Logs</MenuItem>
    //       <MenuItem value={4}>Admit Card Logs</MenuItem>
    //       <MenuItem value={5}>Scorecard Logs</MenuItem>
    //     </Select>
    //   </FormControl>
    //           <BluePrimaryButton
    //             title={"Submit"}
    //             handleSubmit={handlelogs}
    //             // disabled={
    //             //   id == 0 ||
    //             //   coursecandidatelist?.length == 0 ||
    //             //   coursecandidatelist?.[0]?.templatedocs == null ||
    //             //   coursecandidatelist?.[0]?.isadmitcardgenerated == 1 ||
    //             //   isLogicApplied == 1
    //             // }
    //           />
    //              <GreenButton
    //                   // handleSubmit={item.buttonAction}
    //                   title="Download"
    //                 />
    // </Box>
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Select Logs
      </Typography>

      <Stack direction="row" spacing={2} alignItems="center">
        <FormControl sx={{ minWidth: 200 }} size="small">
          <Select value={value} onChange={handleChange} displayEmpty fullWidth>
            <MenuItem value="">Select logs</MenuItem>
            <MenuItem value={1}>Profile Logs</MenuItem>
            <MenuItem value={2}>Course Registration Logs</MenuItem>
            <MenuItem value={3}>Objection Tracker Logs</MenuItem>
            <MenuItem value={4}>Admit Card Logs</MenuItem>
            <MenuItem value={5}>Scorecard Logs</MenuItem>
            {/* <MenuItem value={6}>Login Logs</MenuItem> */}
          </Select>
        </FormControl>
        <Grid item xs={12} md={6} xl={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            type="tel"
            label={
              <span>
                Mobile No / EmailID
                {/* <span className="error" style={{ color: "red" }}>
                  {" "}
                  *
                </span> */}
              </span>
            }
            placeholder="Enter mobile number or emailid"
            {...register("mobileno", {
              required: "Mobile no or emailid is required",
              minLength: {
                value: 10,
                message: "Enter valid mobile number or emailid",
              },
            })}
            InputLabelProps={{ shrink: true }}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
        </Grid>
        <BluePrimaryButton
          title="Submit"
          handleSubmit={handlelogs}
          disabled={value ==""}
        />

        <GreenButton
          title="Download"
          handleSubmit={handledownload}
          disabled={Auditlogs?.length == 0}
        />

      
      </Stack>
    </Box>
  );
}
